import React from 'react';
import './chapters.scss';

function Chapter1({ data }) {
  const { eyebrow, head, copy } = data;
  return (
    <div className="chapters__chapter">
      <div className="chapters__chapter__panelist">
        <div className="chapters__chapter__panelist__dash chapters__chapter__panelist__dash--pink" />
        {eyebrow}
      </div>
      <h3 className="pink">{head}</h3>
      {copy.map((text, i) => {
        return <p key={i}>{text}</p>;
      })}
    </div>
  );
}

export default Chapter1;
